export default "__VITE_ASSET__DNT_gNGl__"